var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"read-only-wrapper"},[_c('div',{staticClass:"__label"},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('div',{staticClass:"__value"},[(_vm.customValue)?[_vm._t("customValue")]:[_vm._v(" "+_vm._s(_vm.value)+" ")]],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }